import {SecurityCodeResponse} from "libs/apiClient";
import {formatDateTime} from "features/discover/functions";

export function SecurityCodesTable({
	securityCodes
}: {
	securityCodes: SecurityCodeResponse[]
}) {
	if (securityCodes.length === 0) {
		return <div className="empty-sub-table">No security codes</div>
	}

    return (
		<table className="discover-table">
			<thead>
				<tr>
					<th>ID</th>
					<th>Code</th>
					<th>Recipient</th>
					<th>Created At</th>
					<th>Expires At</th>
				</tr>
			</thead>
			<tbody>
				{securityCodes.map((sc: SecurityCodeResponse, index) => (
					<tr key={`row-${index}`}>
						<td>{sc.id}</td>
						<td>
							<strong>{sc.code}</strong>
						</td>
						<td>
							{sc.recipient}
						</td>
						<td>
							{formatDateTime(sc.createdAt)}
						</td>
						<td>
							{formatDateTime(sc.expiresAt)}
						</td>
					</tr>
				))}
			</tbody>
		</table>
	)
}
